module.exports = __webpack_public_path__ + "static/04-e2ec9fa687bbb94e9b58bdcbf0074bbb.jpg";